import { render, staticRenderFns } from "./myCollectionList.vue?vue&type=template&id=2493fcac&scoped=true"
import script from "./myCollectionList.vue?vue&type=script&lang=js"
export * from "./myCollectionList.vue?vue&type=script&lang=js"
import style0 from "./myCollectionList.vue?vue&type=style&index=0&id=2493fcac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2493fcac",
  null
  
)

export default component.exports